import { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

export const translations = {
  es: {
    nav: {
      services: 'Servicios',
      about: 'Sobre GTX',
      compare: 'Comparativa',
      diff: 'Diferenciación',
      faq: 'FAQ',
      contact: 'Contacto',
      whatsapp: 'WhatsApp',
      quote: 'Evaluar mi importación',
    },
    seo: {
      title: 'Global Tech Xperts · Importación B2B a Europa vía Países Bajos | GTX IMPORT, EUROPE ENTRY, BUY FOR YOU',
      description: 'Importación B2B para empresas españolas y europeas. Estudiamos y coordinamos tu importación desde fuera de la UE a través de Países Bajos y evaluamos si puede acogerse al IVA diferido. Operativa con clientes europeos para proveedores de fuera de la UE. Especialistas en tecnología Apple y Samsung.',
    },
    hero: {
      badge: 'Importación y operaciones B2B para empresas españolas y europeas',
      titleLine1: 'Importa a Europa con una operativa clara',
      titleLine2: 'y más liquidez para tu empresa.',
      subtitle: 'Estudiamos y coordinamos tu importación desde países fuera de la UE a través de Países Bajos. Evaluamos si tu operación puede acogerse al IVA diferido para evitar adelantar el IVA de importación en aduanas, cuando se cumplan los requisitos aplicables.',
      support: 'Tecnología y otras mercancías, previa evaluación. Especialistas en operaciones B2B de Apple y Samsung.',
      vatNote: 'El IVA diferido no es una exención ni una eliminación del impuesto. Su aplicación depende de la operación y del cumplimiento de los requisitos fiscales y aduaneros.',
      cta1: 'Evaluar mi importación',
      ctaCalendly: 'Reservar reunión de 30 minutos',
      cta3: 'Conoce nuestros tres servicios',
      cta2: 'Hablar por WhatsApp',
      bullet1Title: 'Estructura, no improvisación',
      bullet1Desc: 'Cada operación sigue un proceso definido: evaluación, documentación, coordinación y seguimiento.',
      bullet2Title: 'Un interlocutor único',
      bullet2Desc: 'Una sola persona coordina contigo durante toda la operación.',
      bullet3Title: 'Coordinación vía Países Bajos',
      bullet3Desc: 'Coordinamos la entrada en la UE a través de Países Bajos con los profesionales que correspondan en cada operación.',
      kpi1: 'Tecnología · Apple · Samsung',
      kpi2: 'Otras mercancías, previa evaluación',
      kpi3: 'Operativa vía Países Bajos',
      kpi4: 'Empresas españolas y europeas',
      videoPlaceholder: 'Vídeo de presentación próximamente',
    },
    chooser: {
      tag: '¿Qué necesita tu empresa?',
      title: '¿Qué necesita tu empresa?',
      subtitle: 'Elige tu situación y te llevamos al servicio que corresponde.',
      available: 'Disponible',
      comingSoon: 'Próximamente',
      cases: [
        { q: 'Ya tengo proveedor y quiero importar', service: 'GTX IMPORT', id: 'import', desc: 'Estudiamos y coordinamos tu importación desde fuera de la UE.' },
        { q: 'Soy proveedor fuera de la UE y quiero vender a clientes europeos', service: 'GTX EUROPE ENTRY', id: 'europe', desc: 'Un interlocutor europeo para coordinar la operativa con tus clientes empresariales.' },
        { q: 'Necesito encontrar producto o proveedor', service: 'GTX BUY FOR YOU', id: 'buy', desc: 'Búsqueda de producto en tecnología, Apple y Samsung. Registro de interés.' },
      ],
    },
    services: {
      title: 'Los 3 Servicios',
      heading: 'Tres servicios. Una sola operativa.',
      subtitle: 'Tres servicios para tres situaciones distintas. Cada uno con su alcance y su disponibilidad real.',
      stepsTitle: 'Cómo trabajamos',
      scopeTitle: 'Alcance',
      techLabel: 'Tecnología y electrónica: nuestra especialización.',
      otherLabel: 'Otras mercancías: evaluamos cada operación según producto, origen, destino y requisitos aplicables.',
      // GTX IMPORT
      importTag: 'Servicio 01',
      importTitle: 'GTX IMPORT',
      importSubtitle: 'Conserva la relación con tu proveedor y cuenta con un interlocutor para estudiar y coordinar tu operación de importación.',
      importDefinition: 'Para empresas españolas y europeas que ya tienen un proveedor fuera de la UE y necesitan estudiar o coordinar su importación. Tú mantienes tu proveedor, tu precio y tu margen. GTX estudia la operación y coordina su ejecución con los profesionales que correspondan.',
      importVideoCaption: 'Cómo estudiamos y coordinamos tu importación, paso a paso.',
      importFinalCta: '¿Te encaja? Cuéntanos qué quieres importar.',
      importProblemTitle: 'Qué resuelve',
      importProblem: [
        'Falta de estructura interna para gestionar importaciones.',
        'Errores documentales o logísticos que encarecen la operación.',
        'Dificultad para coordinar transporte, aduana y proveedor.',
        'Necesidad de adelantar el IVA de importación cuando podría no ser necesario.',
      ],
      importIncludesTitle: 'Qué incluye',
      importIncludes: [
        'Evaluación inicial de la operación.',
        'Revisión y coordinación documental (proforma, packing list, factura comercial).',
        'Coordinación logística y aduanera con los profesionales que correspondan.',
        'Evaluación de la posible aplicación del IVA diferido.',
        'Seguimiento hasta el destino acordado.',
        'Interlocutor único durante toda la operación.',
      ],
      importExcludesTitle: 'Qué NO incluye',
      importExcludes: [
        'Búsqueda o sustitución del proveedor.',
        'Asunción del riesgo de producto o calidad.',
        'Funciones de agente de aduanas, representante fiscal o transportista: GTX coordina con los profesionales que intervienen.',
      ],
      importForTitle: 'Para quién',
      importFor: 'Distribuidores, resellers, ecommerce, mayoristas y empresas españolas y europeas que compran a proveedores fuera de la UE.',
      importModelTitle: 'Modelo de cobro',
      importModel: 'Propuesta con alcance y costes antes de iniciar la operación.',
      importAnchor: 'Tú conservas el control de tu operación. Nosotros aportamos estructura y coordinación.',
      importSteps: [
        'Nos explicas qué quieres importar.',
        'Revisamos el encaje operativo, documental y fiscal.',
        'Presentamos una propuesta con alcance y costes.',
        'Coordinamos la operación según las condiciones acordadas.',
      ],
      importCta1: 'Evaluar mi importación',
      importCta2: 'Hablar con un especialista',
      importWhatsapp: 'Quiero evaluar una importación con GTX',

      // GTX EUROPE ENTRY
      europeTag: 'Servicio 02',
      europeTitle: 'GTX EUROPE ENTRY',
      europeSubtitle: 'Un interlocutor europeo para estudiar y coordinar la operativa con tus clientes empresariales en la Unión Europea.',
      europeDefinition: 'Para proveedores, distribuidores y empresas de fuera de la UE que necesitan coordinar operaciones con sus clientes empresariales en Europa. Tú mantienes el producto, el precio y la relación comercial. GTX coordina la operativa europea bajo las condiciones acordadas.',
      europeVideoCaption: 'Cómo coordinamos tu operativa con clientes europeos.',
      europeFinalCta: '¿Te encaja? Hablemos de tu operativa en Europa.',
      europeProblemTitle: 'Qué resuelve',
      europeProblem: [
        'Tus clientes europeos necesitan un interlocutor en la UE.',
        'La documentación y la logística de entrada generan fricción en cada pedido.',
        'Cada incidencia se convierte en una llamada internacional.',
        'Montar una estructura propia en Europa es caro y lento.',
      ],
      europeIncludesTitle: 'Qué incluye (según acuerdo operativo)',
      europeIncludes: [
        'Análisis inicial de encaje y modelo operativo.',
        'Coordinación documental de la operación.',
        'Coordinación logística hasta el cliente europeo.',
        'Coordinación de facturación y cobro, cuando esté incluido en el acuerdo operativo.',
        'Seguimiento e incidencias con un interlocutor único en Europa.',
      ],
      europeExcludesTitle: 'Qué NO incluye',
      europeExcludes: [
        'Captación de clientes europeos ni garantía de ventas.',
        'Representación fiscal, licencias o cobertura jurídica.',
        'Sustitución de las obligaciones legales del proveedor.',
        'Asunción ilimitada de riesgo de producto.',
      ],
      europeForTitle: 'Para quién',
      europeFor: 'Mayoristas, distribuidores, exportadores y fabricantes de fuera de la UE de tecnología —Apple, Samsung y dispositivos móviles— con clientes empresariales en Europa o en negociación.',
      europeModelTitle: 'Modelo de cobro',
      europeModel: 'Condiciones definidas en el acuerdo operativo tras la evaluación inicial.',
      europeAnchor: 'Tus clientes europeos, con un interlocutor en Europa.',
      europeSteps: [
        'Nos cuentas qué vendes y a qué clientes europeos.',
        'Analizamos el encaje operativo y documental.',
        'Definimos juntos el alcance en un acuerdo operativo.',
        'Coordinamos cada operación según lo acordado.',
      ],
      europeCta1: 'Evaluar mi entrada en Europa',
      europeCta2: 'Hablar con un especialista',
      europeWhatsapp: 'Quiero evaluar mi operativa con clientes europeos con GTX',

      // GTX BUY FOR YOU
      buyTag: 'Servicio 03',
      buyTitle: 'GTX BUY FOR YOU',
      buySubtitle: 'Cuéntanos qué producto necesita tu empresa y estudiaremos si podemos ayudarte a encontrar una opción adecuada.',
      buyDefinition: 'Para empresas españolas y europeas que necesitan ayuda para encontrar producto o proveedor en tecnología, especialmente Apple y Samsung. Servicio próximo a lanzarse: déjanos tus necesidades y tus datos para que podamos informarte sobre su disponibilidad.',
      buyVideoCaption: 'Cómo buscamos y evaluamos opciones de producto.',
      buyFinalCta: 'Déjanos tus necesidades y tus datos para que podamos informarte sobre la disponibilidad del servicio.',
      buyProblemTitle: 'Qué resuelve',
      buyProblem: [
        'Dificultad para encontrar producto o proveedor fiable.',
        'Tiempo perdido evaluando opciones sin estructura.',
        'Dependencia de un único proveedor.',
      ],
      buyIncludesTitle: 'Alcance previsto',
      buyIncludes: [
        'Recogida de necesidades.',
        'Búsqueda y evaluación de opciones.',
        'Presentación de propuesta.',
        'Coordinación de la compra según las condiciones acordadas.',
      ],
      buyExcludesTitle: 'Qué NO incluye',
      buyExcludes: [
        'Disponibilidad garantizada de producto.',
        'Presupuesto inmediato.',
        'Mercancías fuera de la especialización tecnológica.',
      ],
      buyForTitle: 'Para quién',
      buyFor: 'Distribuidores, resellers, ecommerce y empresas españolas y europeas que buscan producto o proveedor en tecnología, Apple y Samsung.',
      buyModelTitle: 'Estado',
      buyModel: 'Próximamente. Registramos tu interés y te informaremos sobre la disponibilidad del servicio.',
      buyAnchor: 'Tú nos cuentas qué necesitas. Nosotros estudiamos si podemos ayudarte.',
      buySteps: [
        'Recogida de necesidades.',
        'Búsqueda y evaluación de opciones.',
        'Presentación de propuesta.',
        'Coordinación de la compra según las condiciones acordadas.',
      ],
      buyCta1: 'Registrar mi interés',
      buyCta2: 'Cuéntanos qué necesitas',
      buyWhatsapp: 'Me interesa GTX Buy For You — quiero registrar mi interés',
    },
    compare: {
      title: 'Comparativa de los 3 servicios',
      subtitle: 'Tres servicios. Tres situaciones. Una decisión clara.',
      headers: ['', 'GTX IMPORT', 'GTX EUROPE ENTRY', 'GTX BUY FOR YOU'],
      rows: [
        { label: 'A quién se dirige', values: ['Empresas españolas y europeas que importan desde fuera de la UE', 'Proveedores y empresas de fuera de la UE con clientes empresariales en Europa', 'Empresas españolas y europeas que buscan producto o proveedor'] },
        { label: '¿Ya tiene proveedor?', values: ['Sí', 'Es el proveedor', 'No'] },
        { label: 'Necesidad que resuelve', values: ['Estudiar y coordinar la importación', 'Coordinar la operativa con clientes europeos', 'Encontrar producto o proveedor (tecnología)'] },
        { label: 'Qué coordina GTX', values: ['Evaluación, documentación, logística y aduana con los profesionales que correspondan, IVA diferido si procede', 'Documentación, logística y, según acuerdo, facturación y cobro', 'Búsqueda, evaluación y coordinación de la compra'] },
        { label: 'Disponibilidad', values: ['Disponible', 'Disponible', 'Próximamente'] },
      ],
      ctas: ['Evaluar mi importación', 'Evaluar mi entrada en Europa', 'Registrar mi interés'],
      note: 'GTX coordina la operación. Las funciones de agente de aduanas, representante fiscal o transportista las realizan los profesionales que intervienen en cada operación.',
    },
    diff: {
      title: 'Por qué GTX',
      subtitle: 'Cinco principios operativos para importar, comprar y vender tecnología B2B en Europa con más claridad.',
      items: [
        { title: 'Estructura, no improvisación', desc: 'Cada operación sigue un proceso definido: evaluación, propuesta, coordinación y seguimiento.' },
        { title: 'Un interlocutor único', desc: 'Una sola persona te acompaña de principio a fin. Sin reenvíos ni cadenas internas.' },
        { title: 'Coordinación vía Países Bajos', desc: 'Coordinamos la entrada en la UE a través de Países Bajos y evaluamos si procede el IVA diferido en cada operación.' },
        { title: 'Especialización real', desc: 'Tecnología, especialmente Apple y Samsung. Otras mercancías, previa evaluación.' },
        { title: 'Tú conservas el control', desc: 'Tu proveedor, tu precio y tu margen siguen siendo tuyos. GTX aporta coordinación para reducir errores y mejorar la visibilidad sobre la operación.' },
      ],
    },
    about: {
      tag: 'Sobre GTX',
      title: 'Operativa real, no promesa de marketing',
      subtitle: 'Global Tech Xperts B.V. es una empresa con sede en Rotterdam (Países Bajos) especializada en operaciones B2B de tecnología —principalmente Apple y Samsung— para empresas españolas y europeas. También evaluamos la importación de otras mercancías.',
      paragraph1: 'GTX no es una tienda, ni un broker que pasa contactos, ni un agente de aduanas, ni un transitario. GTX estudia y coordina la operación —documentación, logística, aduana y seguimiento— con un único interlocutor, trabajando con los profesionales que corresponden en cada caso.',
      operationTitle: 'Sede',
      operationValue: 'Rotterdam, Países Bajos · Operaciones con España y el resto de la UE',
      brandsTitle: 'Especialización',
      brandsValue: 'Tecnología: Apple, Samsung y otros dispositivos (nuevo, usado y reacondicionado). Otras mercancías, previa evaluación.',
      suppliersTitle: 'Orígenes habituales',
      suppliersValue: 'Hong Kong, Dubái, Estados Unidos, Japón, Singapur, Turquía',
      marketsTitle: 'Destinos habituales',
      marketsValue: 'España, Italia, Francia, Alemania, Portugal, Países Bajos, Polonia, Austria, Bélgica, Rumanía',
      proofTitle: 'Operaciones tecnológicas',
      proofSubtitle: 'Imágenes reales de operaciones de tecnología. Ilustran nuestra especialización; GTX IMPORT también evalúa otras mercancías.',
      proofVideo1: 'iPhone Pro Max — verificación',
      proofVideo2: 'iPhone Pro — todos los colores',
      proofVideo3: 'Stock listo para expedición',
      notTitle: 'Qué GTX NO es',
      notItems: [
        'No es una tienda de móviles ni vende listas de precios.',
        'No pasa contactos de proveedores.',
        'No es un transitario, una agencia de aduanas ni un representante fiscal.',
        'No promete gestionar cualquier producto: cada operación se evalúa.',
      ],
    },
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        { q: '¿Qué es el IVA diferido y lo puedo aplicar?', a: 'Es un mecanismo que, cuando la operación cumple los requisitos fiscales y aduaneros aplicables, permite no adelantar el IVA de importación en aduana. No es una exención ni una eliminación del impuesto. En GTX IMPORT evaluamos caso por caso si tu operación puede acogerse a él.' },
        { q: '¿Qué mercancías podéis importar?', a: 'Nuestra especialización es la tecnología, especialmente Apple y Samsung. Otras mercancías las evaluamos según producto, origen, destino y requisitos aplicables antes de confirmar si podemos coordinar la operación.' },
        { q: '¿Trabajáis con producto usado o reacondicionado?', a: 'Sí, en tecnología trabajamos producto nuevo, usado y reacondicionado siempre que el origen sea verificable.' },
        { q: '¿GTX es agente de aduanas o transportista?', a: 'No. GTX estudia y coordina la operación. El despacho aduanero, el transporte y, en su caso, la representación fiscal los realizan los profesionales que intervienen en cada operación.' },
        { q: '¿Cuánto tarda la evaluación de una importación?', a: 'Tras recibir tu solicitud revisamos el encaje operativo, documental y fiscal y te contactamos con los siguientes pasos. El plazo depende de la complejidad de la operación.' },
        { q: '¿Estoy fuera de la UE, podéis ayudarme?', a: 'Sí. GTX EUROPE ENTRY está pensado para proveedores y empresas de fuera de la UE que necesitan coordinar la operativa con sus clientes empresariales europeos. No incluye la captación de clientes ni garantiza ventas.' },
        { q: '¿Cuándo estará disponible GTX BUY FOR YOU?', a: 'Está próximo a lanzarse. Puedes registrar tu interés y te informaremos sobre su disponibilidad. No podemos confirmar fecha ni disponibilidad de producto.' },
        { q: '¿Qué pasa si hay una incidencia?', a: 'Te atiende el mismo interlocutor que ha coordinado la operación.' },
      ],
    },
    contact: {
      tag: 'Contacto',
      title: 'Cuéntanos tu operación',
      subtitle: 'Dos pasos. Primero tu necesidad, después tus datos de contacto. Revisaremos el encaje de tu operación y te contactaremos con los siguientes pasos.',
      step1: 'Paso 1 · Tu necesidad',
      step2: 'Paso 2 · Datos de contacto',
      next: 'Continuar',
      back: 'Volver',
      interestBadge: 'Registro de interés · servicio próximamente',
      // Common
      fIsBusiness: '¿Contactas como empresa o autónomo?',
      yes: 'Sí',
      no: 'No',
      negotiating: 'En negociación',
      noPreference: 'Sin preferencia',
      fService: 'Servicio que te interesa',
      fCountry: 'País de la empresa',
      notBusinessNotice: 'Estos servicios están dirigidos a empresas y autónomos con operaciones comerciales.',
      // Import
      fCategory: 'Categoría',
      categories: ['Tecnología y electrónica', 'Otras mercancías'],
      fProduct: 'Producto que deseas importar',
      fOrigin: 'País de origen',
      fDestination: 'País de destino dentro de la UE',
      fValue: 'Valor aproximado de la mercancía (EUR)',
      fQuantity: 'Cantidad o volumen (opcional)',
      fUnit: 'Unidad',
      units: ['Unidades', 'Palés', 'Kg', 'Contenedores', 'Otro'],
      fHasSupplier: '¿Ya tienes proveedor?',
      fTimeline: 'Fecha prevista',
      timelines: ['Próximos 30 días', 'De 1 a 3 meses', 'Más adelante', 'Solo estoy explorando'],
      noSupplierNotice: 'GTX IMPORT está orientado a operaciones en las que ya existe proveedor. Si necesitas encontrar producto o proveedor, consulta GTX BUY FOR YOU (tecnología, Apple y Samsung · próximamente, registro de interés).',
      noSupplierLink: 'Ir a GTX BUY FOR YOU',
      // Europe
      fOriginGoods: 'País de origen de la mercancía',
      fProductCategory: 'Producto o categoría',
      fEuDestinations: 'Países europeos de destino',
      fEuClients: '¿Ya tienes clientes empresariales en Europa?',
      fCoordination: '¿Qué necesitas coordinar?',
      coordinationOptions: ['Documentación', 'Logística', 'Facturación', 'Cobro'],
      fValueVolume: 'Valor o volumen aproximado (opcional)',
      // Buy
      fProductBrand: 'Producto o marca que buscas',
      fCondition: 'Estado del producto',
      conditions: ['Nuevo', 'Usado', 'Reacondicionado', 'Sin preferencia'],
      fDesiredQty: 'Cantidad deseada',
      fDestCountry: 'País de destino',
      fIndicativeTimeline: 'Plazo orientativo',
      fExtraNeeds: 'Necesidades adicionales',
      // Step 2
      fCompany: 'Empresa',
      fName: 'Nombre y apellidos',
      fPosition: 'Cargo (opcional)',
      fEmail: 'Correo de contacto profesional',
      fPhone: 'Teléfono con prefijo internacional',
      fComment: 'Comentario adicional (opcional)',
      fSource: '¿Cómo nos has conocido?',
      fAcceptPrivacy: 'He leído y acepto la política de privacidad',
      fAcceptMarketing: 'Quiero recibir comunicaciones comerciales de GTX (opcional)',
      // Options
      countryPlaceholder: 'Selecciona país',
      countries: ['España', 'Italia', 'Francia', 'Alemania', 'Portugal', 'Países Bajos', 'Polonia', 'Austria', 'Bélgica', 'Rumanía', 'Irlanda', 'Otro país UE', 'Reino Unido', 'Fuera de la UE'],
      servicePlaceholder: 'Selecciona un servicio',
      serviceOptions: [
        { id: 'import', label: 'GTX IMPORT — ya tengo proveedor y quiero importar' },
        { id: 'europe', label: 'GTX EUROPE ENTRY — soy proveedor fuera de la UE' },
        { id: 'buy', label: 'GTX BUY FOR YOU — busco producto o proveedor (próximamente)' },
        { id: 'unsure', label: 'No estoy seguro — quiero orientación' },
      ],
      sourcePlaceholder: 'Selecciona (opcional)',
      sources: ['TikTok', 'Google', 'LinkedIn', 'Recomendación', 'Feria / Evento', 'Otro'],
      submitEvaluation: 'Solicitar evaluación',
      submitInterest: 'Registrar mi interés',
      submitGeneric: 'Enviar consulta',
      submitting: 'Enviando...',
      whatsappLine: 'Si tu caso es urgente, escríbenos directamente por WhatsApp.',
      whatsappBtn: 'Hablar por WhatsApp',
      successTitle: 'Hemos recibido tu solicitud.',
      successMessage: 'Revisaremos el encaje de tu operación y te contactaremos con los siguientes pasos.',
      successImportExtra: 'Puedes reservar una reunión de 30 minutos para comentar tu importación.',
      successCalendly: 'Reservar reunión',
      successOtherExtra: 'Si lo prefieres, también puedes escribirnos por WhatsApp o email.',
      successInterestTitle: 'Hemos registrado tu interés.',
      successInterestMessage: 'Te contactaremos con información sobre la disponibilidad del servicio.',
      requiredHint: 'Los campos marcados con * son obligatorios. No necesitas adjuntar documentos en este primer contacto.',
      errorRequired: 'Revisa los campos obligatorios.',
      errorPrivacy: 'Debes aceptar la política de privacidad.',
      errorSubmit: 'No hemos podido enviar tu solicitud. Inténtalo de nuevo o escríbenos por WhatsApp o email.',
    },
    footer: {
      tagline: 'Importación y operaciones B2B para empresas españolas y europeas. Especialistas en tecnología Apple y Samsung.',
      services: 'Servicios',
      company: 'Empresa',
      legal: 'Legal',
      legalNotice: 'Aviso legal',
      privacy: 'Política de privacidad',
      cookies: 'Política de cookies',
      contactTitle: 'Contacto',
      copyright: 'Todos los derechos reservados.',
    },
    whatsappHome: 'Hola, vengo de la web de GTX. Me gustaría más información sobre vuestros servicios.',
    operativa: { title: 'Operativa GTX' },
  },
  en: {
    nav: {
      services: 'Services',
      about: 'About GTX',
      compare: 'Comparison',
      diff: 'Why GTX',
      faq: 'FAQ',
      contact: 'Contact',
      whatsapp: 'WhatsApp',
      quote: 'Assess my import',
    },
    seo: {
      title: 'Global Tech Xperts · B2B Import into Europe via the Netherlands | GTX IMPORT, EUROPE ENTRY, BUY FOR YOU',
      description: 'B2B import for Spanish and European companies. We assess and coordinate your import from outside the EU through the Netherlands and evaluate whether it qualifies for deferred import VAT. Operations with European business customers for non-EU suppliers. Apple and Samsung technology specialists.',
    },
    hero: {
      badge: 'B2B import and operations for Spanish and European companies',
      titleLine1: 'Import into Europe with a clear operation',
      titleLine2: 'and more liquidity for your business.',
      subtitle: 'We assess and coordinate your import from non-EU countries through the Netherlands. We evaluate whether your operation can qualify for deferred import VAT so you avoid advancing import VAT at customs, where the applicable requirements are met.',
      support: 'Technology and other goods, subject to assessment. Specialists in Apple and Samsung B2B operations.',
      vatNote: 'Deferred VAT is not an exemption or elimination of the tax. Its application depends on the operation and on meeting the applicable tax and customs requirements.',
      cta1: 'Assess my import',
      ctaCalendly: 'Book a 30-minute meeting',
      cta3: 'Discover our three services',
      cta2: 'Chat on WhatsApp',
      bullet1Title: 'Structure, not improvisation',
      bullet1Desc: 'Every operation follows a defined process: assessment, documentation, coordination and follow-up.',
      bullet2Title: 'A single point of contact',
      bullet2Desc: 'One person coordinates with you throughout the whole operation.',
      bullet3Title: 'Coordination via the Netherlands',
      bullet3Desc: 'We coordinate entry into the EU through the Netherlands with the relevant professionals for each operation.',
      kpi1: 'Technology · Apple · Samsung',
      kpi2: 'Other goods, subject to assessment',
      kpi3: 'Operations via the Netherlands',
      kpi4: 'Spanish and European companies',
      videoPlaceholder: 'Presentation video coming soon',
    },
    chooser: {
      tag: 'What does your business need?',
      title: 'What does your business need?',
      subtitle: 'Pick your situation and we take you to the right service.',
      available: 'Available',
      comingSoon: 'Coming soon',
      cases: [
        { q: 'I already have a supplier and want to import', service: 'GTX IMPORT', id: 'import', desc: 'We assess and coordinate your import from outside the EU.' },
        { q: 'I am a non-EU supplier and want to sell to European customers', service: 'GTX EUROPE ENTRY', id: 'europe', desc: 'A European point of contact to coordinate operations with your business customers.' },
        { q: 'I need to find a product or supplier', service: 'GTX BUY FOR YOU', id: 'buy', desc: 'Product sourcing in technology, Apple and Samsung. Register your interest.' },
      ],
    },
    services: {
      title: 'The 3 Services',
      heading: 'Three services. One operation.',
      subtitle: 'Three services for three different situations. Each with its real scope and availability.',
      stepsTitle: 'How we work',
      scopeTitle: 'Scope',
      techLabel: 'Technology and electronics: our specialisation.',
      otherLabel: 'Other goods: we assess each operation based on product, origin, destination and applicable requirements.',
      // GTX IMPORT
      importTag: 'Service 01',
      importTitle: 'GTX IMPORT',
      importSubtitle: 'Keep the relationship with your supplier and have a single point of contact to assess and coordinate your import operation.',
      importDefinition: 'For Spanish and European companies that already have a supplier outside the EU and need to assess or coordinate their import. You keep your supplier, your price and your margin. GTX assesses the operation and coordinates its execution with the relevant professionals.',
      importVideoCaption: 'How we assess and coordinate your import, step by step.',
      importFinalCta: 'Sounds right? Tell us what you want to import.',
      importProblemTitle: 'What it solves',
      importProblem: [
        'Lack of internal structure to manage imports.',
        'Documentation or logistics errors that make the operation more expensive.',
        'Difficulty coordinating transport, customs and supplier.',
        'Having to advance import VAT when it might not be necessary.',
      ],
      importIncludesTitle: 'What it includes',
      importIncludes: [
        'Initial assessment of the operation.',
        'Document review and coordination (proforma, packing list, commercial invoice).',
        'Logistics and customs coordination with the relevant professionals.',
        'Assessment of the possible application of deferred VAT.',
        'Follow-up to the agreed destination.',
        'A single point of contact throughout the operation.',
      ],
      importExcludesTitle: 'What it does NOT include',
      importExcludes: [
        'Searching for or replacing the supplier.',
        'Assuming product or quality risk.',
        'Acting as customs agent, fiscal representative or carrier: GTX coordinates with the professionals involved.',
      ],
      importForTitle: 'Who it is for',
      importFor: 'Distributors, resellers, ecommerce, wholesalers and Spanish and European companies buying from suppliers outside the EU.',
      importModelTitle: 'Pricing model',
      importModel: 'Proposal with scope and costs before the operation starts.',
      importAnchor: 'You keep control of your operation. We bring structure and coordination.',
      importSteps: [
        'You tell us what you want to import.',
        'We review the operational, documentary and tax fit.',
        'We present a proposal with scope and costs.',
        'We coordinate the operation under the agreed conditions.',
      ],
      importCta1: 'Assess my import',
      importCta2: 'Talk to a specialist',
      importWhatsapp: 'I want to assess an import with GTX',

      // GTX EUROPE ENTRY
      europeTag: 'Service 02',
      europeTitle: 'GTX EUROPE ENTRY',
      europeSubtitle: 'A European point of contact to assess and coordinate operations with your business customers in the European Union.',
      europeDefinition: 'For non-EU suppliers, distributors and companies that need to coordinate operations with their business customers in Europe. You keep the product, the price and the commercial relationship. GTX coordinates the European operation under the agreed conditions.',
      europeVideoCaption: 'How we coordinate your operations with European customers.',
      europeFinalCta: 'Sounds right? Let’s talk about your operations in Europe.',
      europeProblemTitle: 'What it solves',
      europeProblem: [
        'Your European customers need a point of contact in the EU.',
        'Entry documentation and logistics create friction on every order.',
        'Every incident becomes an international call.',
        'Setting up your own structure in Europe is expensive and slow.',
      ],
      europeIncludesTitle: 'What it includes (per operating agreement)',
      europeIncludes: [
        'Initial fit analysis and operating model.',
        'Documentary coordination of the operation.',
        'Logistics coordination to the European customer.',
        'Invoicing and collection coordination, where included in the operating agreement.',
        'Follow-up and incident handling with a single point of contact in Europe.',
      ],
      europeExcludesTitle: 'What it does NOT include',
      europeExcludes: [
        'Acquiring European customers or any sales guarantee.',
        'Fiscal representation, licences or legal coverage.',
        'Replacing the supplier’s legal obligations.',
        'Unlimited assumption of product risk.',
      ],
      europeForTitle: 'Who it is for',
      europeFor: 'Non-EU wholesalers, distributors, exporters and manufacturers of technology —Apple, Samsung and mobile devices— with business customers in Europe or in negotiation.',
      europeModelTitle: 'Pricing model',
      europeModel: 'Conditions defined in the operating agreement after the initial assessment.',
      europeAnchor: 'Your European customers, with a point of contact in Europe.',
      europeSteps: [
        'You tell us what you sell and to which European customers.',
        'We analyse the operational and documentary fit.',
        'We define the scope together in an operating agreement.',
        'We coordinate each operation as agreed.',
      ],
      europeCta1: 'Assess my entry into Europe',
      europeCta2: 'Talk to a specialist',
      europeWhatsapp: 'I want to assess my operations with European customers with GTX',

      // GTX BUY FOR YOU
      buyTag: 'Service 03',
      buyTitle: 'GTX BUY FOR YOU',
      buySubtitle: 'Tell us what product your business needs and we will assess whether we can help you find a suitable option.',
      buyDefinition: 'For Spanish and European companies that need help finding a product or supplier in technology, especially Apple and Samsung. Service launching soon: leave us your needs and details so we can inform you about its availability.',
      buyVideoCaption: 'How we search for and evaluate product options.',
      buyFinalCta: 'Leave us your needs and details so we can inform you about the availability of the service.',
      buyProblemTitle: 'What it solves',
      buyProblem: [
        'Difficulty finding a reliable product or supplier.',
        'Time lost evaluating options without structure.',
        'Dependence on a single supplier.',
      ],
      buyIncludesTitle: 'Planned scope',
      buyIncludes: [
        'Needs gathering.',
        'Search and evaluation of options.',
        'Proposal presentation.',
        'Purchase coordination under the agreed conditions.',
      ],
      buyExcludesTitle: 'What it does NOT include',
      buyExcludes: [
        'Guaranteed product availability.',
        'Immediate quotes.',
        'Goods outside the technology specialisation.',
      ],
      buyForTitle: 'Who it is for',
      buyFor: 'Distributors, resellers, ecommerce and Spanish and European companies looking for a product or supplier in technology, Apple and Samsung.',
      buyModelTitle: 'Status',
      buyModel: 'Coming soon. We register your interest and will inform you about the availability of the service.',
      buyAnchor: 'You tell us what you need. We assess whether we can help.',
      buySteps: [
        'Needs gathering.',
        'Search and evaluation of options.',
        'Proposal presentation.',
        'Purchase coordination under the agreed conditions.',
      ],
      buyCta1: 'Register my interest',
      buyCta2: 'Tell us what you need',
      buyWhatsapp: 'I am interested in GTX Buy For You — I want to register my interest',
    },
    compare: {
      title: 'Comparison of the 3 services',
      subtitle: 'Three services. Three situations. One clear decision.',
      headers: ['', 'GTX IMPORT', 'GTX EUROPE ENTRY', 'GTX BUY FOR YOU'],
      rows: [
        { label: 'Who it is for', values: ['Spanish and European companies importing from outside the EU', 'Non-EU suppliers and companies with business customers in Europe', 'Spanish and European companies looking for a product or supplier'] },
        { label: 'Already has a supplier?', values: ['Yes', 'Is the supplier', 'No'] },
        { label: 'Need it solves', values: ['Assess and coordinate the import', 'Coordinate operations with European customers', 'Find a product or supplier (technology)'] },
        { label: 'What GTX coordinates', values: ['Assessment, documentation, logistics and customs with the relevant professionals, deferred VAT where applicable', 'Documentation, logistics and, per agreement, invoicing and collection', 'Search, evaluation and purchase coordination'] },
        { label: 'Availability', values: ['Available', 'Available', 'Coming soon'] },
      ],
      ctas: ['Assess my import', 'Assess my entry into Europe', 'Register my interest'],
      note: 'GTX coordinates the operation. Customs agent, fiscal representative or carrier functions are performed by the professionals involved in each operation.',
    },
    diff: {
      title: 'Why GTX',
      subtitle: 'Five operating principles to import, buy and sell B2B technology in Europe with more clarity.',
      items: [
        { title: 'Structure, not improvisation', desc: 'Every operation follows a defined process: assessment, proposal, coordination and follow-up.' },
        { title: 'A single point of contact', desc: 'One person accompanies you from start to finish. No forwarding, no internal chains.' },
        { title: 'Coordination via the Netherlands', desc: 'We coordinate entry into the EU through the Netherlands and assess whether deferred VAT applies to each operation.' },
        { title: 'Real specialisation', desc: 'Technology, especially Apple and Samsung. Other goods, subject to assessment.' },
        { title: 'You keep control', desc: 'Your supplier, your price and your margin remain yours. GTX brings coordination to reduce errors and improve visibility over the operation.' },
      ],
    },
    about: {
      tag: 'About GTX',
      title: 'Real operations, not marketing promises',
      subtitle: 'Global Tech Xperts B.V. is a company based in Rotterdam (the Netherlands) specialised in B2B technology operations —mainly Apple and Samsung— for Spanish and European companies. We also assess the import of other goods.',
      paragraph1: 'GTX is not a shop, not a broker passing on contacts, not a customs agent and not a freight forwarder. GTX assesses and coordinates the operation —documentation, logistics, customs and follow-up— with a single point of contact, working with the relevant professionals in each case.',
      operationTitle: 'Headquarters',
      operationValue: 'Rotterdam, the Netherlands · Operations with Spain and the rest of the EU',
      brandsTitle: 'Specialisation',
      brandsValue: 'Technology: Apple, Samsung and other devices (new, used and refurbished). Other goods, subject to assessment.',
      suppliersTitle: 'Usual origins',
      suppliersValue: 'Hong Kong, Dubai, United States, Japan, Singapore, Turkey',
      marketsTitle: 'Usual destinations',
      marketsValue: 'Spain, Italy, France, Germany, Portugal, Netherlands, Poland, Austria, Belgium, Romania',
      proofTitle: 'Technology operations',
      proofSubtitle: 'Real images of technology operations. They illustrate our specialisation; GTX IMPORT also assesses other goods.',
      proofVideo1: 'iPhone Pro Max — verification',
      proofVideo2: 'iPhone Pro — all colours',
      proofVideo3: 'Stock ready for shipment',
      notTitle: 'What GTX is NOT',
      notItems: [
        'Not a phone shop and does not sell price lists.',
        'Does not pass on supplier contacts.',
        'Not a freight forwarder, customs agency or fiscal representative.',
        'Does not promise to handle any product: every operation is assessed.',
      ],
    },
    faq: {
      title: 'Frequently asked questions',
      items: [
        { q: 'What is deferred VAT and can I apply it?', a: 'It is a mechanism that, where the operation meets the applicable tax and customs requirements, allows you not to advance import VAT at customs. It is not an exemption or elimination of the tax. In GTX IMPORT we assess case by case whether your operation can qualify.' },
        { q: 'Which goods can you import?', a: 'Our specialisation is technology, especially Apple and Samsung. Other goods are assessed based on product, origin, destination and applicable requirements before we confirm whether we can coordinate the operation.' },
        { q: 'Do you work with used or refurbished products?', a: 'Yes, in technology we work with new, used and refurbished products as long as the origin is verifiable.' },
        { q: 'Is GTX a customs agent or a carrier?', a: 'No. GTX assesses and coordinates the operation. Customs clearance, transport and, where applicable, fiscal representation are performed by the professionals involved in each operation.' },
        { q: 'How long does an import assessment take?', a: 'After receiving your request we review the operational, documentary and tax fit and contact you with the next steps. Timing depends on the complexity of the operation.' },
        { q: 'I am outside the EU, can you help me?', a: 'Yes. GTX EUROPE ENTRY is designed for non-EU suppliers and companies that need to coordinate operations with their European business customers. It does not include customer acquisition or sales guarantees.' },
        { q: 'When will GTX BUY FOR YOU be available?', a: 'It is launching soon. You can register your interest and we will inform you about its availability. We cannot confirm a date or product availability.' },
        { q: 'What happens if there is an incident?', a: 'You are attended by the same person who coordinated the operation.' },
      ],
    },
    contact: {
      tag: 'Contact',
      title: 'Tell us about your operation',
      subtitle: 'Two steps. First your need, then your contact details. We will review the fit of your operation and contact you with the next steps.',
      step1: 'Step 1 · Your need',
      step2: 'Step 2 · Contact details',
      next: 'Continue',
      back: 'Back',
      interestBadge: 'Interest registration · service coming soon',
      fIsBusiness: 'Are you contacting us as a company or freelancer?',
      yes: 'Yes',
      no: 'No',
      negotiating: 'In negotiation',
      noPreference: 'No preference',
      fService: 'Service you are interested in',
      fCountry: 'Company country',
      notBusinessNotice: 'These services are aimed at companies and freelancers with commercial operations.',
      fCategory: 'Category',
      categories: ['Technology and electronics', 'Other goods'],
      fProduct: 'Product you want to import',
      fOrigin: 'Country of origin',
      fDestination: 'Destination country within the EU',
      fValue: 'Approximate value of the goods (EUR)',
      fQuantity: 'Quantity or volume (optional)',
      fUnit: 'Unit',
      units: ['Units', 'Pallets', 'Kg', 'Containers', 'Other'],
      fHasSupplier: 'Do you already have a supplier?',
      fTimeline: 'Expected date',
      timelines: ['Next 30 days', '1 to 3 months', 'Later', 'Just exploring'],
      noSupplierNotice: 'GTX IMPORT is aimed at operations where a supplier already exists. If you need to find a product or supplier, see GTX BUY FOR YOU (technology, Apple and Samsung · coming soon, interest registration).',
      noSupplierLink: 'Go to GTX BUY FOR YOU',
      fOriginGoods: 'Country of origin of the goods',
      fProductCategory: 'Product or category',
      fEuDestinations: 'European destination countries',
      fEuClients: 'Do you already have business customers in Europe?',
      fCoordination: 'What do you need to coordinate?',
      coordinationOptions: ['Documentation', 'Logistics', 'Invoicing', 'Collection'],
      fValueVolume: 'Approximate value or volume (optional)',
      fProductBrand: 'Product or brand you are looking for',
      fCondition: 'Product condition',
      conditions: ['New', 'Used', 'Refurbished', 'No preference'],
      fDesiredQty: 'Desired quantity',
      fDestCountry: 'Destination country',
      fIndicativeTimeline: 'Indicative timeline',
      fExtraNeeds: 'Additional needs',
      fCompany: 'Company',
      fName: 'Full name',
      fPosition: 'Position (optional)',
      fEmail: 'Professional contact email',
      fPhone: 'Phone with international prefix',
      fComment: 'Additional comment (optional)',
      fSource: 'How did you hear about us?',
      fAcceptPrivacy: 'I have read and accept the privacy policy',
      fAcceptMarketing: 'I want to receive commercial communications from GTX (optional)',
      countryPlaceholder: 'Select country',
      countries: ['Spain', 'Italy', 'France', 'Germany', 'Portugal', 'Netherlands', 'Poland', 'Austria', 'Belgium', 'Romania', 'Ireland', 'Other EU country', 'United Kingdom', 'Outside the EU'],
      servicePlaceholder: 'Select a service',
      serviceOptions: [
        { id: 'import', label: 'GTX IMPORT — I already have a supplier and want to import' },
        { id: 'europe', label: 'GTX EUROPE ENTRY — I am a non-EU supplier' },
        { id: 'buy', label: 'GTX BUY FOR YOU — I am looking for a product or supplier (coming soon)' },
        { id: 'unsure', label: 'Not sure — I would like guidance' },
      ],
      sourcePlaceholder: 'Select (optional)',
      sources: ['TikTok', 'Google', 'LinkedIn', 'Referral', 'Trade fair / Event', 'Other'],
      submitEvaluation: 'Request assessment',
      submitInterest: 'Register my interest',
      submitGeneric: 'Send enquiry',
      submitting: 'Sending...',
      whatsappLine: 'If your case is urgent, write to us directly on WhatsApp.',
      whatsappBtn: 'Chat on WhatsApp',
      successTitle: 'We have received your request.',
      successMessage: 'We will review the fit of your operation and contact you with the next steps.',
      successImportExtra: 'You can book a 30-minute meeting to discuss your import.',
      successCalendly: 'Book a meeting',
      successOtherExtra: 'If you prefer, you can also write to us on WhatsApp or by email.',
      successInterestTitle: 'We have registered your interest.',
      successInterestMessage: 'We will contact you with information about the availability of the service.',
      requiredHint: 'Fields marked with * are required. No documents are needed at this first contact.',
      errorRequired: 'Please check the required fields.',
      errorPrivacy: 'You must accept the privacy policy.',
      errorSubmit: 'We could not send your request. Please try again or write to us on WhatsApp or by email.',
    },
    footer: {
      tagline: 'B2B import and operations for Spanish and European companies. Apple and Samsung technology specialists.',
      services: 'Services',
      company: 'Company',
      legal: 'Legal',
      legalNotice: 'Legal notice',
      privacy: 'Privacy policy',
      cookies: 'Cookie policy',
      contactTitle: 'Contact',
      copyright: 'All rights reserved.',
    },
    whatsappHome: 'Hello, I come from the GTX website. I would like more information about your services.',
    operativa: { title: 'GTX Operation' },
  },
};

const LANG_KEY = "gtx_lang";
const initialLanguage = () => {
  const saved = localStorage.getItem(LANG_KEY);
  if (saved === "es" || saved === "en") return saved;
  return (navigator.language || "").toLowerCase().startsWith("es") ? "es" : "en";
};

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(initialLanguage);
  const setLanguage = useCallback((lang) => {
    localStorage.setItem(LANG_KEY, lang);
    setLanguageState(lang);
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value !== undefined ? value : key;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(language === 'es' ? 'en' : 'es');
  }, [language, setLanguage]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
